import { useCallback, useContext, useState } from 'react';
import { Content, useContent } from 'src/contexts/ContentContext';
import { ModalContext } from 'src/contexts/ModalContext';
import { vars } from 'src/core/themes';
import { Button, Stack } from 'src/core/ui';
import { IconsFill, PlusIcon } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';

import { FilterInput } from '../../Settings/Views/VendorManagement/Vendors/components/FilterInput';
import { NotificationModal } from './NotificationModal';
import { NotificationsTable } from './NotificationsTable';

export const Notifications = () => {
  const notifications = useContent(ContentId.Notifications);
  const [searchText, setSearchText] = useState<string>('');
  const { setModal, closeModal } = useContext(ModalContext);

  const onAddClick = useCallback(() => {
    setModal({
      children: <NotificationModal isOpen={true} onClose={closeModal} />,
      clickOutsideToClose: true,
      centered: true,
      size: 'sm',
    });
  }, [closeModal, setModal]);

  return (
    <Stack
      direction="column"
      gap="l"
      style={{ height: '100%', padding: '20px' }}
    >
      <Stack justifyContent="spaceBetween" alignItems="center">
        <div style={{ fontSize: '24px', fontWeight: 'bold' }}>
          <Content id={ContentId.Notifications} />
        </div>
        <Stack direction="row" gap="m" alignItems="center">
          <FilterInput
            onSearchTextChanged={setSearchText}
            searchEntityLabel={notifications}
          />
          <Button variant="outline" onClick={onAddClick}>
            <PlusIcon fill={IconsFill.currentColor} size={vars.iconSize.s} />
            <span style={{ whiteSpace: 'nowrap' }}>
              <Content id={ContentId.NewNotification} />
            </span>
          </Button>
        </Stack>
      </Stack>
      <NotificationsTable searchText={searchText} />
    </Stack>
  );
};
